// src/pages/ImpressumPage.js
import React from 'react';
import LegalPage from '../components/LegalPage';
import impressumUrl from '../content/impressum.md';

export default function ImpressumPage() {
  return <LegalPage title="Impressum" contentUrl={impressumUrl} />;
}
